import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import NavBar from "../components/Navigation/Navbar";
import { hasRouteAccess, getUserEmail, getDefaultRoute } from "../utils/permissions";

const isAuthenticated = () => {
  var token = localStorage.getItem("token");
  if (token == null) {
    return false;
  } else {
    return true;
  }
};

export const ProtectedRoute = () => {
  const location = useLocation();
  const userEmail = getUserEmail();

  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  // Check if user has access to current route
  if (!hasRouteAccess(location.pathname, userEmail)) {
    return <Navigate to={getDefaultRoute(userEmail)} replace />;
  }

  return (
    <div className="flex-order">
      <NavBar />
      <Outlet className="example" />
    </div>
  );
};
